import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Bottom navigation bar for mobile — used across client / driver / admin panels.
 * Renders as a fixed bottom bar on mobile only (lg:hidden).
 */
export const BottomNav = ({ items, testIdPrefix = "bottom-nav" }) => {
  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-[#0D0E10]/95 backdrop-blur-md border-t border-[#2E2F33]"
      data-testid={`${testIdPrefix}-bar`}
    >
      <ul className="grid grid-cols-5 max-w-md mx-auto">
        {items.map((it, idx) => {
          const Icon = it.icon;
          return (
            <li key={idx}>
              <NavLink
                to={it.to}
                end={it.end}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center gap-1 py-3 transition-colors ${
                    isActive ? "text-[#C9A227]" : "text-[#A0A0A5]"
                  }`
                }
                data-testid={`${testIdPrefix}-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {({ isActive }) => (
                  <>
                    <div className={`p-1.5 rounded-lg ${isActive ? "bg-[#C9A227]/10" : ""}`}>
                      <Icon size={18} />
                    </div>
                    <span className="text-[10px] font-body uppercase tracking-wider">{it.label}</span>
                  </>
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BottomNav;
